import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
} from "@angular/core";
import {
  FullContractorAccount,
  FullContractorAccountResponse,
  GetAccountsFullContractorResponseData,
} from "./interfaces/database-interface";
import { DataSource, SelectionModel } from "@angular/cdk/collections";
import { MatSnackBar, MatTableDataSource } from "@angular/material";
import { BehaviorSubject, Subscription } from "rxjs";
import { ConfirmationDialogService } from "../../../shared/dialog/services/confirmation-dialog.service";
import { ContractorSelectorAccountService } from "./service/contractor-selector-account.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-full-contractor-account-selector",
  templateUrl: "./account-selector.component.html",
  styleUrls: ["./account-selector.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FullContractorAccountSelectorComponent
  implements OnInit, OnDestroy
{

  checkboxLegalAgreements = false;
  isCountButtonToConfirm = false;
  columnTitles: string[] = ["select", "position", "database"];

  itemsDataSource = new AccountsDataSource(this._accountFullContractorService);
  dataItemsSource: MatTableDataSource<FullContractorAccount>;

  rowsSelection = new SelectionModel<FullContractorAccount>(true, []);
  loadingSubject$ = this._accountFullContractorService.loadingSubject$;
  loadingSendInformationSubject$ =
    this._accountFullContractorService.loadingSubject$;

  constructor(
    private _dialogService: ConfirmationDialogService,
    private _router: Router,
    private _accountFullContractorService: ContractorSelectorAccountService,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.isCountButtonToConfirm = true;
    this._accountFullContractorService.dataCacheStream$.subscribe(
      (items: GetAccountsFullContractorResponseData[]) => {
        this.dataItemsSource = new MatTableDataSource(items["Accounts"]);
      }
    );
  }

  /** Whether the number of selected elements matches the total number of rows. **/
  isAllSelected() {
    const selectedCount = this.rowsSelection.selected.length;
    const rowsCount = this.dataItemsSource.data.length;
    if (selectedCount) {
      if (this.checkboxLegalAgreements) {
        this.isCountButtonToConfirm = false;
      } else {
        this.isCountButtonToConfirm = true;
      }
    } else {
      this.isCountButtonToConfirm = true;
    }
    return selectedCount === rowsCount;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. **/
  toggleAllRows() {
    console.log(this.rowsSelection);
    if (this.isAllSelected()) {
      this.rowsSelection.clear();
      return;
    }

    this.rowsSelection.select(...this.dataItemsSource.data);
  }

  /** The label for the checkbox on the passed row **/
  checkboxColumnTitle(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? "deselect" : "select"} all`;
    }
    return `${this.rowsSelection.isSelected(row) ? "deselect" : "select"} row ${
      row.id + 1
    }`;
  }

  confirmSelectionToSendDB() {
    const selectedCount = this.rowsSelection.selected.length;
    const selectedItems = this.rowsSelection.selected;

    this._accountFullContractorService.loadingSendInformationSubject.next(true);
    this._accountFullContractorService.loadingSubject.next(true);
    this.isCountButtonToConfirm = true;
    console.log("ITEM COUNT SELECTED", selectedCount);
    console.log("ITEM SELECTED", selectedItems);
    this._dialogService
      .confirmationDialog(
        "Confirm selection",
        `This action can't be undone,
       By clicking Accept you are acknowledging
       that the accounts that you selected are correct`,
        "Accept",
        "Cancel"
      )
      .afterClosed()
      .subscribe((result: boolean): void => {
        if (result) {
          const userDataSet = JSON.parse(
            localStorage.getItem("formFullContractor")
          );
          if (userDataSet !== null) {
            userDataSet.UserName =
              this._accountFullContractorService.userNameStream.value;
            // const accountsSelected = selectedItems;
            this._accountFullContractorService
              .sendInformationFullContractor(userDataSet)
              .subscribe((result: FullContractorAccountResponse) => {
                if (result.Success) {
                  this._snackBar.open(result.Message, "Ok", {
                    verticalPosition: "top",
                  });
                  this._accountFullContractorService.loadingSendInformationSubject.next(
                    false
                  );
                  this._accountFullContractorService.loadingSubject.next(false);
                  this.isCountButtonToConfirm = false;

                } else {
                  this._snackBar.open(result.Message, "Ok", {
                    verticalPosition: "top",
                  });
                  this._accountFullContractorService.loadingSendInformationSubject.next(
                    false
                  );
                  this._accountFullContractorService.loadingSubject.next(false);
                  this.isCountButtonToConfirm = false;
                  this._router.navigate(["v2/full-contractor"]);
                }
              });
          } else {
            this._router.navigate(["v2/full-contractor"]);
          }
        } else {
          this._accountFullContractorService.loadingSendInformationSubject.next(
            false
          );
          this._accountFullContractorService.loadingSubject.next(false);
          this.isCountButtonToConfirm = false;
        }
      });
  }

  cancelAccountSelection(): void {
    this._router.navigate(["../"]);
  }

  acceptLegalAgreementsChange(): void {
    this.isCountButtonToConfirm = this.checkboxLegalAgreements;
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    localStorage.removeItem("formFullContractor");
  }
}

export class AccountsDataSource extends DataSource<FullContractorAccount> {
  private items: FullContractorAccount[];
  private dataStream = new BehaviorSubject<FullContractorAccount[]>([]);
  private readonly _subscription = new Subscription();

  constructor(
    private _contractorSelectorAccountService: ContractorSelectorAccountService
  ) {
    super();
  }

  connect() {
    this._subscription.add(
      this._contractorSelectorAccountService
        .getData()
        .subscribe((items: GetAccountsFullContractorResponseData[]): void => {
          this.items = items["Accounts"];
          this.dataStream.next(this.items);
          this._contractorSelectorAccountService.loadingSubject.next(false);
        })
    );

    return this.dataStream;
  }

  disconnect(): void {
    this._subscription.unsubscribe();
  }
}
